import L from 'leaflet';
import {
  createElementHook,
  createElementObject,
  useLayerLifecycle,
  useLeafletContext
} from '@react-leaflet/core';

/*
* You'll notice some `(L as any)` dotted around this file. This is due to Typescript
* not working well with the Laflet convention of extending objects.
* It is possible, it seems, to extend the L.Marker class in the usual way you would in Typescript
* but this breaks the existing leaflet convention, plus I don't want to make too many changes
* to code in this JS - TS migration. If you want to have a go in the future with this, go ahead!
* https://stackoverflow.com/questions/65691920/extend-leaflet-marker-with-typescript
*/

(L as any).RotatedMarker = L.Marker.extend({
  options: {
    rotationAngle: 0,
    rotationOrigin: ''
  },

  initialize: function(latlng, options) {
    (L as any).Marker.prototype.initialize.call(this);

    L.Util.setOptions(this, options);
    this._latlng = L.latLng(latlng);

    var iconOptions = this.options.icon && this.options.icon.options;
    var iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
    if (iconAnchor) {
      iconAnchor = iconAnchor[0] + 'px ' + iconAnchor[1] + 'px';
    }

    this.options.rotationOrigin =
      this.options.rotationOrigin || iconAnchor || 'center bottom';
    this.options.rotationAngle = this.options.rotationAngle || 0;

    // Ensure marker keeps rotated during dragging
    this.on('drag', function(e) {
      e.target._applyRotation();
    });
  },

  onRemove: function(map) {
    L.Marker.prototype.onRemove.call(this, map);
  },

  _setPos: function(pos) {
    (L as any).Marker.prototype._setPos.call(this, pos);
    this._applyRotation();
  },

  _setLatLng: function(pos) {
    L.Marker.prototype.setLatLng.call(this, pos);
    this._applyRotation();
    this.update();
  },

  _applyRotation: function() {
    if (this.options.rotationAngle) {
      this._icon.style[
        L.DomUtil.TRANSFORM + 'Origin'
      ] = this.options.rotationOrigin;
      if (!this._icon.style[L.DomUtil.TRANSFORM].includes('rotateZ')) {
        this._icon.style[L.DomUtil.TRANSFORM] +=
          ' rotateZ(' + this.options.rotationAngle + 'deg)';
      }
    }
  },

  setRotationAngle: function(angle) {
    this.options.rotationAngle = angle;
    this.update();
    return this;
  },

  setRotationOrigin: function(origin) {
    this.options.rotationOrigin = origin;
    this.update();
    return this;
  }
});

(L as any).rotatedMarker = function(latlng, options) {
  return new (L as any).RotatedMarker(latlng, options);
};

export var RotatedMarker = (L as any).RotatedMarker;

function getBounds(props) {
  return L.latLng(props.position);
}

function createSquare(props, context) {
  return createElementObject(
    new (L as any).rotatedMarker(getBounds(props), {
      rotationAngle: props.heading,
      icon: props.icon
    }),
    context
  );
}

function updateSquare(instance, props, prevProps) {
  if (
    props.position[0] !== prevProps.position[0] ||
    props.position[1] !== prevProps.position[1]
  ) {
    try {
      instance._setLatLng(L.latLng(props.position));
    } catch {}
  }
  if (props.heading !== prevProps.heading) {
    instance.setRotationAngle(props.heading);
  }
}

const useSquareElement = createElementHook(createSquare, updateSquare);

export function UavMarker(props) {
  const context = useLeafletContext();
  const elementRef = useSquareElement(props, context);
  useLayerLifecycle(elementRef.current, context);

  return null;
}
